<template>
    <div class="product-type" >
        <h2>产品中心</h2>
        <ul>
            <li @mouseenter="mouseEnter(index)" 
                @mouseleave="mouseLeave"
                v-for="(item,index) in type"
                :key="item.id"
                :class="{active: index==enterIndex || index==actIndex}"
                @click="productType(index,item.name)"
            >
                {{item.name}}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'ProductType',
    props: {
        type: Array,
        index: Number
    },
    mounted () {
    },
    watch: {
        index (newVal) {
            this.actIndex = newVal
        }
    },
    data () {
        return {
            actIndex: 0,
            enterIndex: -1
        }
    },
    methods: {
        mouseEnter (index) {
            this.enterIndex = index
        },
        mouseLeave () {
            this.enterIndex = -1
        },
        productType(index,name){
            this.actIndex = index
            this.$emit('changeType',name)
        },
    },
    computed: {
    },
    destroyed () {
        document.removeEventListener('scroll',this.typeFixed)
    }
}
</script>

<style lang="stylus" scoped>
    @import '~styles/varible.styl'
    @import '~styles/mixins.styl'
    .product-type
        text-align: center
        min-width: 1440px
        max-width: 1920px
        margin: 0 auto
        background: #fff
        padding: 96px 0 36px
        h2
            position: relative
            font-weight: 600
            color: #333
            font-size: 42px
            padding-bottom: 94px
            letter-spacing: 2px
            &:after
                content: ''
                position: absolute
                margin-left: -36px
                display: block
                border-bottom: 1px solid #333
                width: 72px
                margin-top: 40px
                left: 50%
        ul
            text-align: center
            margin: 0 auto 2.6em
            font-size: 14px
            li
                display: inline-block
                width: 8%
                line-height: 3.6em
                cursor: pointer
                margin-right: 0.8%
                color: #333
                background: #e0e0e0
                border-radius: 3px
            .active
                color: #fff
                background: $black    
</style>



// WEBPACK FOOTER //
// src/components/pc/ProductType.vue